<template>
  <v-snackbar
    v-model="$store.state.snackbar.show"
    :color="$store.state.snackbar.colorBg"
    :left="$store.state.snackbar.xPosition == 'left'"
    :right="$store.state.snackbar.xPosition == 'right'"
    :top="$store.state.snackbar.yPosition == 'top'"
    :bottom="$store.state.snackbar.yPosition == 'bottom'"
    :center="$store.state.snackbar.yPosition == 'center'"
    :timeout="$store.state.snackbar.timeout"
    :content-class="customTxtColor"
  >
    <h2 class="mb-1">{{ $store.state.snackbar.title }}</h2>
    {{ $store.state.snackbar.txt }}

    <template v-slot:action="{ attrs }">
      <v-btn
        v-bind="attrs"
        :color="$store.state.snackbar.colorBtn"
        :class="customTxtColor"
        fab
        x-small
        elevation="3"
        @click="$store.state.snackbar.show = false"
      >
        <v-icon>mdi-check</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  computed: {
    customTxtColor() {
      return this.$store.state.snackbar.colorTxt != "" ? this.$store.state.snackbar.colorTxt + "--text" : "";
    },
  },
  methods: {},
};
</script>
